/* Must be compatible with snake_case variant in @performyard/models */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ReviewCycleAssignedSubjectData () {
        return ReviewCycleAssignedSubjectData;
    },
    get ReviewCycleAutomatedAssignedSubjectData () {
        return ReviewCycleAutomatedAssignedSubjectData;
    },
    get ReviewCycleClosedData () {
        return ReviewCycleClosedData;
    },
    get ReviewCycleDeletedData () {
        return ReviewCycleDeletedData;
    },
    get ReviewCycleRemovedSubjectData () {
        return ReviewCycleRemovedSubjectData;
    },
    get ReviewCycleResourceLog () {
        return ReviewCycleResourceLog;
    },
    get ReviewCycleResourceLogData () {
        return ReviewCycleResourceLogData;
    },
    get ReviewCycleResourceType () {
        return ReviewCycleResourceType;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _baseresourcelog = require("../base-resource-log");
const ReviewCycleResourceType = _zod.z.literal("review-cycle");
const ReviewCycleChangeType = _zod.z.union([
    _zod.z.literal("close"),
    _zod.z.literal("add-subject"),
    _zod.z.literal("remove-subject"),
    _zod.z.literal("automated-add-subject"),
    // Backwards compatible
    _zod.z.literal("add-subjects"),
    _zod.z.literal("remove-subjects")
]);
const ReviewCycleAssignedSubjectData = _zod.z.object({
    subjectId: _utilsisomorphic.transformObjectId,
    reviewId: _utilsisomorphic.transformObjectId,
    reviewReports: _models.ReviewReportModel.array(),
    reviewReportForms: _models.ReviewCycleFormModel.array(),
    criteria: _zod.z.string().optional()
});
const ReviewCycleAutomatedAssignedSubjectData = ReviewCycleAssignedSubjectData.extend({
    criteria: _zod.z.object({
        field: _zod.z.literal("is_manager").or(_zod.z.instanceof(_bson.ObjectId)),
        fieldName: _zod.z.string(),
        value: _models.FieldValueModel,
        valueName: _zod.z.string().or(_zod.z.string().or(_zod.z.undefined()).array()).optional()
    }).array()
});
const ReviewCycleRemovedSubjectData = _zod.z.object({
    reviewId: _utilsisomorphic.transformObjectId,
    subjectId: _utilsisomorphic.transformObjectId
});
const ReviewCycleClosedData = _zod.z.object({
    closedReviews: _utilsisomorphic.transformObjectId.array()
});
const ReviewCycleDeletedData = _zod.z.object({
    deletedReviews: _utilsisomorphic.transformObjectId.array()
});
const ReviewCycleResourceLogData = _baseresourcelog.BaseResourceLog.shape.data.or(ReviewCycleAssignedSubjectData).or(ReviewCycleRemovedSubjectData).or(ReviewCycleClosedData).or(ReviewCycleDeletedData).or(_models.ReviewCycleModel.partial());
const ReviewCycleResourceLog = _baseresourcelog.BaseResourceLog.extend({
    resourceType: ReviewCycleResourceType,
    changeType: _baseresourcelog.BaseResourceChangeType.or(ReviewCycleChangeType),
    data: ReviewCycleResourceLogData
});
